import { useEffect, useState } from "react";
import { ArrowPathIcon } from "@heroicons/react/24/outline";
import { RulesModel } from "../../../account/accountApiSlice";
import ButtonWithForm from "../../../../components/ButtonWithForm";
import ResetPasswordForm from "../../ResetPasswordForm";
import { ResetPasswordViewModel, useResetUserPasswordByAdminMutation } from "../../usersApiSlice";

interface ResetPasswordProps {
	userId: number;
	name: string;
	isResettingForStudent: boolean;
	rules: RulesModel;
	setSuccessMessage: (message: string) => void;
	setErrorMessage: (message: string) => void;
}

export default function ResetPasswordByAdmin(props: ResetPasswordProps) {
	const [resetModel, setResetModel] = useState<ResetPasswordViewModel>({
		userId: props.userId,
		password: "",
		confirmPassword: "",
	});
	const [resetPassword, setResetPassword] = useState("");
	const [resetConfirmPassword, setResetConfirmPassword] = useState("");
	const [disableResetPasswordConfirm, setDisableResetPasswordConfirm] = useState(true);

	const [resetUserPassword] = useResetUserPasswordByAdminMutation();

	useEffect(() => {
		setResetModel({
			...resetModel,
			password: resetPassword,
			confirmPassword: resetConfirmPassword,
		});
	}, [resetPassword, resetConfirmPassword]);

	function handleResetUserPassword() {
		if (resetModel) {
			resetUserPassword(resetModel)
				.unwrap()
				.then(() => {
					props.setErrorMessage("");
					props.setSuccessMessage("The password has been successfully reset.");
				})
				.catch((error) => {
					props.setSuccessMessage("");
					props.setErrorMessage(
						error.data
							? `There was an error resetting the password. ${error.data}`
							: "There was an unexpected error while trying to reset the password."
					);
				})
				.finally(() => scrollTo(0, 0));
		}
	}

	function updatePassword(password: string) {
		setResetPassword(password);
	}

	function updateConfirmPassword(confirmPassword: string) {
		setResetConfirmPassword(confirmPassword);
	}

	return (
		<ButtonWithForm
			id="reset-password-button"
			className="btn btn-action"
			title={`Reset Password: ${props.name}`}
			confirmLabel="Save"
			onConfirm={handleResetUserPassword}
			disableConfirm={disableResetPasswordConfirm}
			form={
				<ResetPasswordForm
					rules={props.rules}
					isResettingForStudent={props.isResettingForStudent}
					updatePassword={updatePassword}
					updateConfirmPassword={updateConfirmPassword}
					disableConfirm={setDisableResetPasswordConfirm}
				/>
			}>
			<span className="flex items-center">
				<ArrowPathIcon className="size-4 mr-2" /> Reset
			</span>
		</ButtonWithForm>
	);
}
